import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

@Pipe({
  name: 'userRole',
  standalone: false,
})
export class UserRolePipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: string | null | undefined): string {
    if (!value) {
      return this.translate.instant('common.unknown');
    }

    const key = `enums.userRole.${value}`;
    const translated = this.translate.instant(key);
    return translated !== key ? translated : value;
  }
}
